export default "__VITE_ASSET__Bq15Pfci__"